import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
export var DEFAULT_LOCALE = 'en';
var localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
export var getCodesFromLocale = function getCodesFromLocale(locale) {
  var match = localeRegex.exec(locale);
  if (match) {
    var _match = _slicedToArray(match, 3),
      language = _match[1],
      country = _match[2];
    return {
      language: language.toLowerCase(),
      country: country === null || country === void 0 ? void 0 : country.toUpperCase()
    };
  }
  // TODO: Use error service to log:
  // eslint-disable-next-line no-console
  console.error('Unable to determine language and country from invalid locale.');
  return undefined;
};
var loadLazyMessages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lazyMessages, language, country) {
    var _yield$default, _yield, _ref2;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (_ref2 = country && lazyMessages["".concat(language, "_").concat(country)] || lazyMessages[language] || lazyMessages.en) === null || _ref2 === void 0 ? void 0 : _ref2();
        case 2:
          _context.t2 = _yield = _context.sent;
          _context.t1 = _context.t2 === null;
          if (_context.t1) {
            _context.next = 6;
            break;
          }
          _context.t1 = _yield === void 0;
        case 6:
          if (!_context.t1) {
            _context.next = 10;
            break;
          }
          _context.t3 = void 0;
          _context.next = 11;
          break;
        case 10:
          _context.t3 = _yield.default;
        case 11:
          _context.t4 = _yield$default = _context.t3;
          _context.t0 = _context.t4 !== null;
          if (!_context.t0) {
            _context.next = 15;
            break;
          }
          _context.t0 = _yield$default !== void 0;
        case 15:
          if (!_context.t0) {
            _context.next = 19;
            break;
          }
          _context.t5 = _yield$default;
          _context.next = 20;
          break;
        case 19:
          _context.t5 = {};
        case 20:
          return _context.abrupt("return", _context.t5);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadLazyMessages(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var useLazyMessages = function useLazyMessages(lazyMessages, language, country) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  useEffect(function () {
    loadLazyMessages(lazyMessages, language, country).catch(function () {
      return {};
    }).then(setMessages);
  }, [country, language, lazyMessages, setMessages]);
  return messages;
};